module.exports = __webpack_public_path__ + "img/bullet-damage.44e5edff.png";